export enum ECouponConstraint {
  all = 'all',
  none = 'none',
  specific = 'specific',
}

export enum ECouponType {
  percentage = 'percentage',
  fixed_amount = 'fixed_amount',
}

export enum ECouponStatus {
  active = 'active',
  archived = 'archived',
  expired = 'expired',
}

export enum ECouponDuration {
  one_time = 'one_time',
  forever = 'forever',
  limited_period = 'limited_period',
}

export enum ECouponApplyOn {
  invoice_amount = 'invoice_amount',
  each_specified_item = 'each_specified_item',
}

export enum ECouponApplyOnItemsConstraints {
  plan = 'plan',
  addon = 'addon',
}
